module.exports = __webpack_public_path__ + "static/portfolio-teamalert-99c326735d7138ca138814d4a43878d4.png";